import React, { Component } from 'react'

class Profile extends Component {
  render() {
    return <div> Hello </div>
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/Profile.js